/**
 * Where a stock-opname `meta.errors` string should land on the count sheet (docs/STOCK_OPNAME_API.md §1).
 * Photo helpers are shared with stock-request (`shrinkImage` in ./stockRequest).
 */
export type StockOpnameErrorTarget = 'inactive' | 'lines' | 'countedStock' | 'product' | 'photoTooLarge' | 'uploadFailed' | 'photo' | 'generic';

export function classifyStockOpnameError(msg: string): StockOpnameErrorTarget {
    if (msg === 'POS user is inactive or locked') return 'inactive';
    if (msg.startsWith('lines must')) return 'lines';
    if (msg.startsWith('countedStock') || msg.startsWith('each line needs') || msg.startsWith('duplicate productPointId')) return 'countedStock';
    if (/^product .*does not belong/.test(msg)) return 'product';
    if (msg.startsWith('proof must be at most') || msg.startsWith('image must be at most')) return 'photoTooLarge';
    if (msg.startsWith('Failed to upload proof image')) return 'uploadFailed';
    if (msg.startsWith('proof')) return 'photo';
    return 'generic';
}

/** Raw units on both sides. */
export const varianceOf = (counted: number, system: number) => counted - system;

/** The id in `product 123 does not belong to this shop`, or null. */
export function productIdFromMessage(msg: string): number | null {
    const m = /^product (\d+) does not belong/.exec(msg);
    return m ? Number(m[1]) : null;
}
